<template>
    <div class="clients">

        <div class="clients__title">
            Devis
        </div>

        <div class="clients__subtitle">
            Recherche devis
        </div>

        <DevisCustomFilter :filters="filters" />

        <template v-if="!isBusy">
            <template v-if="devises.data.length > 0">
                <div class="clients__table">
                    <div class="clients__table__item" v-for='devis in devises.data'>
                        <div class="clients__table__item--cell">{{ parseDate(devis.created_at) }}</div>
                        <div class="clients__table__item--cell">{{ parseName(devis) }}</div>
                        <div class="clients__table__item--cell">{{ parsePrice(devis) }}</div>
                        <div class="clients__table__item--cell icon-cell">
                            <font-awesome-icon prefix="fas" icon="file-signature" @click="showDetails(devis)" />
                        </div>
                        <div class="clients__table__item--cell icon-cell">
                            <font-awesome-icon prefix="fas" icon="trash" @click="removeQuote(devis)" />
                        </div>
                    </div>
                </div>
                <pagination :data="devises" @pagination-change-page="getDevises"></pagination>
            </template>
            <template v-else>
                <div class="subscribes-empty">Il n'y a aucun client pour ce type de garantie à ce jour.</div>
            </template>


        </template>
        <template v-else>
            <Preloader />
        </template>
    </div>
</template>

<script>
import DevisCustomFilter from '@/components/Devis/DevisCustomFilter';
import Preloader from '@/components/Preloader';
import pdfPreviewMixin from '../../mixins/pdfPreviewMixin';
import { CLIENT_CIVILITY } from "../../constants/client";

export default {
    name: 'Devis',
    components: { DevisCustomFilter, Preloader },
    mixins: [pdfPreviewMixin],
    data() {
        return {
            devises: {
                data: []
            },
            filters: {
                start_date: null,
                emd_date: null,
                full_name: '',
                category: '',
            },
            isBusy: true,
            filterParams: {
                pdf: 0,
            },
            sortParams: {
                sort: 'id|desc',

            },
        }
    },
    computed: {
        mechanic_id() {
            if (this.$store.getters.isSarrutAdmin) {
                return 4857;
            }
            else if (this.$store.getters.isSagaAdmin) {
                return 4870;
            }
            else
                return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
        },
    },
    methods: {
        getDevises(page = 1) {
            this.isLoading = true;
            let url = (this.isDealer()) ? 'garantie/dealer-search?page=' : 'garantie/search?page=' + page,
                data = {
                    mechanic_id: this.mechanic_id,
                    ...this.filterParams,
                    ...this.sortParams,
                    ...this.getFilters(),
                };
            this.apiGet(url, data)
                .then(response => {
                    this.devises = response.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.isBusy = false;
                })
        },
        showDetails(devis) {
            let id = devis.id,
                prefix = '';

            if (+devis.mechanic.is_dealer === 1) {
                prefix = '/garantie-camping-car-dealer-view/';
            }
            else if (+devis.mechanic.representative_id === 58) {
                switch (devis.category) {
                    case "1":
                        prefix = '/garantie-camping-cars-view/';
                        break; //camping
                    case "2":
                        prefix = '/garantie-autos-view/';
                        break; //auto
                    case "3":
                        prefix = '/garantie-motos-view/';
                        break; //moto
                }
            }
            else {
                switch (devis.category) {
                    case "1":
                        prefix = '/garantie-camping-car-view/';
                        break; //camping
                    case "2":
                        if (devis.is_monthly === 1) {
                            prefix = '/garantie-auto-mensualisee-view/';
                        } else {
                            prefix = '/garantie-auto-view/';
                        }
                        break; //auto
                    case "3":
                        prefix = '/garantie-moto-view/';
                        break; //moto
                }
            }

            this.$store.dispatch('backToDevisEnable');

            if (this.isTest()) {
                prefix = prefix.replace("-view", "-v2")
            }

            this.$router.push(prefix + id);
        },
        removeQuote(devis) {
            this.$confirm(
                {
                    message: 'Voulez-vous vraiment supprimer ce devis?',
                    button: {
                        no: 'NON',
                        yes: 'OUI'
                    },
                    /**
                     * Callback Function
                     * @param {Boolean} confirm
                     */
                    callback: confirm => {
                        if (confirm) {
                            let url = 'garantie/delete';
                            this.apiPost(url, { ids: devis.id }).then((response) => {
                                window.location.href = '/devis';
                            }).catch(error => {
                                console.log(error.response.data);
                            })
                        }
                    }
                }
            );
        },
        getFilters() {
            let data = {};
            this.filters.start_date ? data.start_date = this.filters.start_date : '';
            this.filters.end_date ? data.end_date = this.filters.end_date : '';
            this.filters.full_name ? data.full_name = this.filters.full_name : '';
            this.filters.category ? data.category = this.filters.category : '';
            return data;
        },
        parseDate(date) {
            return this.moment(date).format('DD/MM/YYYY');
        },
        parseName(devis) {
            let client = devis.client;
            if (client) {
                if (+client.civility === CLIENT_CIVILITY.SOCIETE.ID) {
                    return `${client.last_name} ${client.name_of_signatory}`;
                } else {
                    return `${client.first_name} ${client.last_name}`;
                }
            }
            return ' - ';
        },
        parsePrice(devis) {
            let amount = 0;
            if (this.isDealer()) {
                if (+devis.assistance_price > 0) {
                    amount = +(devis.price + devis.assistance_price);
                } else {
                    amount = devis.price || 0;
                }
            }
            else {
                if (devis.is_monthly === 1) {
                    amount = devis.monthly_price || 0;
                } else {
                    amount = devis.price || 0;
                }
            }
            return `${amount} €` || `-`;
            // return `${devis.amount} €` || `-`;
        },
        showPdfAndConfirmQuote(id) {
            this.show_pdf(id);
            window.location.href = '/merci';
        },
        isDealer() {
            return this.$store.getters.isDealer;
        },
        isTest() {
            return this.$store.getters.isTest;
        },
    },
    mounted() {
        this.getDevises();
        this.$eventBus.$on('get-devis', this.getDevises);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Devis/Devis.vue